import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { Tables } from "../../../../components/Elements/Tables/Tables";
import { Button, Pagination } from "antd";
import { ReactComponent as EyeIcon } from "../../../../assets/svgs/eye-icon.svg";
import { ReactComponent as EditIcon } from "../../../../assets/svgs/edit-icon.svg";
import { ReactComponent as FilterIcon } from "../../../../assets/svgs/filter-icon.svg";
import { SearchBar } from "../../../../components/Elements/Search/SearchBar";
import { useNavigate, useLocation } from "react-router-dom";
import SortData from "../../../../components/Elements/SortData.js/SortData";
import { Badge } from "../../../../components/Elements/TextStyles/Badge";
import { IoArrowBackCircleOutline } from "react-icons/io5";
import TextStyles from "../../../../components/Elements/TextStyles/TextStyles";
import FilterAssignedForm from "../../../Organization/components/AssignedForms/FilterAssigedForm";
import { getApi } from "../../../../api/api_instance";
import { API_URLS } from "../../../../api/apiUrls";
import PopupCard from "../../../Auth/PopupCard";
const MobileFormCard = ({ item, index, navigate, setErrorPopup }) => {
  const [isVisible, setIsVisible] = useState(false);

  React.useEffect(() => {
    const timer = setTimeout(() => setIsVisible(true), index * 100);
    return () => clearTimeout(timer);
  }, [index]);

  const getStatusColor = (status) => {
    switch (status) {
      case "active":
      case "completed":
      case "assigned":
        return "bg-green-50 text-green-700 border-green-200";
      case "pending":
        return "bg-yellow-50 text-yellow-700 border-yellow-200";
      case "inactive":
      case "rejected":
        return "bg-red-50 text-red-700 border-red-200";
      default:
        return "bg-gray-50 text-gray-700 border-gray-200";
    }
  };

  return (
    <div
      className={`transform transition-all duration-500 ease-out ${
        isVisible ? "translate-y-0 opacity-100" : "translate-y-4 opacity-0"
      }`}
    >
      <div
        className="bg-white rounded-xl shadow-md border border-gray-100 p-4 mb-4 hover:shadow-lg transition-all duration-300 hover:scale-[1.02] active:scale-[0.98]"
        style={{
          background: "linear-gradient(135deg, #ffffff 0%, #f8fffe 100%)",
        }}
      >
        <div className="flex justify-between items-start mb-3">
          <div className="flex items-center gap-2">
            <div className="w-8 h-8 bg-[#06513D] text-white rounded-full flex items-center justify-center text-sm font-semibold">
              #{item.serial}
            </div>
          </div>
          <div
            className={`px-3 py-1 rounded-full text-xs font-medium border ${getStatusColor(item.status)}`}
          >
            {item.status}
          </div>
        </div>
        <div className="flex justify-between items-center mb-3">
          <span className="text-sm font-medium text-gray-600">Form Name</span>
          <h3 className="font-semibold text-[#06513D] text-right max-w-[65%] leading-tight">
            {item.formName}
          </h3>
        </div>
        <div className="flex justify-between items-center mb-3">
          <span className="text-sm font-medium text-gray-600">Project</span>
          <p className="text-gray-800 text-sm text-right max-w-[65%] bg-gray-50 px-3 py-1 rounded-lg">
            {item.projectName}
          </p>
        </div>
        <div className="flex justify-between items-center mb-4">
          <span className="text-sm font-medium text-gray-600">End Date</span>
          <p className="text-gray-800 text-sm text-right bg-gray-50 px-3 py-1 rounded-lg">
            {item.endDate}
          </p>
        </div>
        <div className="flex justify-center gap-3 pt-3 border-t border-gray-100">
          <button
            onClick={() => {
              if (item.status === "Access Paused") {
                setErrorPopup({
                  title: "Form Access Temporarily Paused",
                  message:
                    "Your access to this form has been temporarily paused by your administrator. You no longer have permission to view, edit, or submit data for this assignment. Please contact your supervisor or administrator for further information.",
                });
                return;
              }
              if (
                item.status === "Access Removed" ||
                item.status === "Access Revoked"
              ) {
                setErrorPopup({
                  title: "Form Access Revoked",
                  message:
                    "Your access to this form has been revoked by your administrator. You no longer have permission to view, edit, or submit data for this assignment. Please contact your supervisor or administrator for further information.",
                });
                return;
              }
              navigate(`/employee/form-assigned/view/${item.templateId}`, {
                state: {
                  formName: item.formName,
                  formType: item.formType,
                  templateId: item.templateId,
                  projectId: item.projectId,
                  userId: item.userId,
                  id: item.user_id,
                  standardFormAllotmentId: item.standardFormAllotmentId,
                },
              });
            }}
            className="flex items-center gap-2 px-4 py-2 bg-blue-50 text-blue-700 rounded-lg hover:bg-blue-100 transition-colors duration-200 text-sm font-medium"
          >
            <EyeIcon className="w-4 h-4" />
            View
          </button>
          <button className="flex items-center gap-2 px-4 py-2 bg-green-50 text-green-700 rounded-lg hover:bg-green-100 transition-colors duration-200 text-sm font-medium">
            <EditIcon className="w-4 h-4" />
            Edit
          </button>
        </div>
      </div>
    </div>
  );
};

const FormAssigned = () => {
  const navigate = useNavigate();
  const token = useSelector((state) => state.auth.authToken);
  const user = useSelector((state) => state.auth.user);

  const [formData, setFormData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [sortBy, setSortBy] = useState(null);
  const [sortOrder, setSortOrder] = useState(null);
  const [openFilterDialog, setOpenFilterDialog] = useState(false);
  const location = useLocation();
  const [currentPage, setCurrentPage] = useState(
    location.state?.currentPage || 1,
  );
  const [loading, setLoading] = useState(false);
  const [apiLoading, setApiLoading] = useState(true);
  const [totalForms, setTotalForms] = useState(0);
  const [popup, setpopup] = useState(false);
  const [errorPopup, setErrorPopup] = useState(null);
  const pageSize = 10;

  const [apiParams, setApiParams] = useState({
    limit: pageSize,
    skip: 0,
    sort: "-createdAt",
    search: "",
    status: "",
  });
  useEffect(() => {
    navigate(location.pathname, {
      replace: true,
      state: {
        ...location.state,
        currentPage,
        apiParams,
      },
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentPage, apiParams, navigate, location.pathname]);
  const headers = [
    { label: "Sr. No.", key: "serial" },
    { label: "Form Name", key: "formName" },
    { label: "Project Name", key: "projectName" },
    { label: "Period", key: "period" },
    { label: "Assigned Date", key: "assigneddate" },
    { label: "End Date", key: "endDate" },
    { label: "Status", key: "status" },
    { label: "Form Type", key: "formType" },
    { label: "Action", key: "action" },
  ];

  const transformApiData = (apiData) => {
    let serialCounter = apiParams.skip + 1;
    return apiData.map((allotment) => {
      const userAllotment = allotment.user;
      const isStandard = allotment.formType === "standard";
      const uniqueId = `${isStandard ? "form" : "custom"}-${allotment._id}-${userAllotment._id}`;

      return {
        _id: uniqueId,
        serial: serialCounter++,
        formName:
          allotment.template?.title || allotment.template?.name || "N/A",
        projectName:
          allotment.project?.project_name || allotment.project?.name || "N/A",
        period: allotment.period || "N/A",
        assigneddate: allotment.createdAt
          ? new Date(allotment.createdAt).toLocaleDateString("en-GB")
          : "N/A",
        endDate: userAllotment.endDate
          ? new Date(userAllotment.endDate).toLocaleDateString("en-GB")
          : "N/A",
        allotmentDate: userAllotment.allotmentDate
          ? new Date(userAllotment.allotmentDate).toLocaleDateString("en-GB")
          : "N/A",
        status: userAllotment.status || "Pending",
        formType: isStandard ? "Standard Form" : "Custom Form",
        templateId: allotment.templateId,
        projectId: allotment.projectId,
        sections: userAllotment.sections || [],
        createdAt: userAllotment.createdAt,
        projectType: allotment.project?.project_type,
        projectStatus: allotment.project?.status,
        templateDescription: allotment.template?.description,
        userId: userAllotment.id,
        user_id: userAllotment._id,
        standardFormAllotmentId: allotment._id,
        clientId: allotment.template?.client,
        progress: allotment.progress || null,
      };
    });
  };

  // ✅ FIXED: Proper data fetching on mount and when params change
  useEffect(() => {
    // console.log("tokennnn->>>>", token);
    let isMounted = true;

    const fetchFormsData = async () => {
      const userId = user?.id || user?._id;

      if (!userId) {
        setApiLoading(false);
        return;
      }

      try {
        setApiLoading(true);

        const response = await getApi({
          apiUrl: API_URLS.GET_ALL_STANDARD_DYNAMIC_FORMS(
            userId,
            apiParams.limit,
            apiParams.skip,
            apiParams.sort,
            apiParams.search,
            apiParams.status,
          ),
          token: token,
        });

        if (!isMounted) return;

        if (response.success && response.data) {
          const transformedData = transformApiData(response.data);
          setFormData(transformedData);
          setFilteredData(transformedData);
          setTotalForms(response.total || transformedData.length);
        } else {
          setFormData([]);
          setFilteredData([]);
        }
      } catch (error) {
        console.error("Error fetching forms data:", error);
        if (isMounted) {
          setFormData([]);
          setFilteredData([]);
        }
      } finally {
        if (isMounted) {
          setApiLoading(false);
        }
      }
    };

    fetchFormsData();

    return () => {
      isMounted = false;
    };
  }, [token, user, apiParams]); //  user ko directly include kiya

  const searchTimeout = React.useRef(null);
  const handleSearch = (searchTerm) => {
    if (searchTimeout.current) clearTimeout(searchTimeout.current);
    searchTimeout.current = setTimeout(() => {
      setApiParams((prev) => ({
        ...prev,
        search: searchTerm,
        skip: 0,
      }));
      setCurrentPage(1);
    }, 400);
  };

  const handleSort = (key, order) => {
    const sortedData = SortData({ data: filteredData, key, order });
    setFilteredData(sortedData);
    setSortBy(key);
    setSortOrder(order);
  };

  const handleFilterApply = (filterParams) => {
    const newParams = {
      ...apiParams,
      ...filterParams,
      skip: 0,
    };
    setApiParams(newParams);
    setCurrentPage(1);
  };

  const currentPageData = filteredData;

  const getStatusBadge = (status) => {
    const statusConfig = {
      assigned: { color: "success", text: "Assigned" },
      completed: { color: "success", text: "Completed" },
      pending: { color: "warning", text: "Pending" },
      active: { color: "success", text: "Active" },
      inactive: { color: "error", text: "Inactive" },
    };

    const config = statusConfig[status?.toLowerCase()] || {
      color: "default",
      text: status || "Unknown",
    };
    return (
      <Badge text={config.text} color={config.color} widthsize="w-[140px]" />
    );
  };

  if (apiLoading && formData.length === 0 && !apiParams.search) {
    return (
      <div className="w-full max-w-full overflow-x-hidden">
        <div className="px-3 sm:px-4 md:px-6 lg:px-0 mb-20 sm:mb-6 md:mb-6">
          <div className="flex justify-center items-center py-20">
            <div className="relative">
              <div className="w-12 h-12 border-4 border-[#06513D] border-t-transparent rounded-full animate-spin"></div>
              <div className="absolute inset-0 w-12 h-12 border-4 border-[#06513D] border-opacity-20 rounded-full"></div>
            </div>
            <span className="ml-3 text-[#06513D] font-medium">
              Loading forms...
            </span>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="w-full max-w-full overflow-x-hidden">
      <div className="px-3 sm:px-4 md:px-6 lg:px-0 mb-20 sm:mb-6 md:mb-6">
        <div className="flex flex-wrap justify-end text-xs h-5 font-light gap-1 sm:gap-2">
          <p>Home</p>
          <span>/</span>
          <TextStyles style={{ color: "#06513D" }}>Assigned Form</TextStyles>
        </div>

        <div className="flex items-center gap-2 sm:gap-3 mb-1 text-lg sm:text-xl font-bold flex-wrap">
          <IoArrowBackCircleOutline
            onClick={() => navigate(-1)}
            className="w-7 h-7 sm:w-8 sm:h-8 md:w-10 md:h-10 text-[#06513D] hover:text-white hover:bg-[#06513D] rounded-full transition cursor-pointer flex-shrink-0"
          />
          <div className="text-[#06513D] font-[Calibri] text-[16px] sm:text-[18px] md:text-[20px] font-bold">
            Assigned Form
          </div>
        </div>

        <div
          className="w-full overflow-hidden"
          style={{
            border: "1px solid #3BA2B959",
            borderRadius: "10px",
            paddingTop: "15px",
            boxShadow: "0px 0px 16px 0px #3BA2B91F",
            backgroundColor: "#fff",
          }}
        >
          <div className="px-3 sm:px-4 md:px-6 mb-4">
            <div className="hidden lg:flex justify-between items-center">
              <div className="flex gap-4 items-center">
                <div className="px-6 xl:px-8 h-[42px] flex items-center justify-center border border-[#06513D] bg-[#B6D4D933] rounded-md text-[#06513D] text-sm xl:text-base font-light whitespace-nowrap">
                  TOTAL FORMS {filteredData.length}
                </div>
                <SearchBar
                  width="280px"
                  height="42px"
                  onSearch={handleSearch}
                />
              </div>
              <div className="flex gap-4">
                <Button
                  style={{ background: "#E6EDEB", border: "solid 1px #0087A3" }}
                  className="text-[12px] text-[#06513D] font-light hover:!bg-[#F8F8F8] hover:!text-[#06513D] !border-[#06513D]  px-4 py-5 h-[42px] flex items-center"
                  onClick={() => setOpenFilterDialog(true)}
                >
                  <FilterIcon className="mr-2" />
                  FILTER
                </Button>
              </div>
            </div>

            <div className="hidden md:flex lg:hidden flex-col gap-3">
              <div className="flex justify-between items-center">
                <div className="px-4 h-[38px] flex items-center justify-center border border-[#06513D] bg-[#B6D4D933] rounded-md text-[#06513D] text-sm font-light whitespace-nowrap">
                  TOTAL FORMS {filteredData.length}
                </div>
                <Button
                  style={{ background: "#E6EEEC", border: "solid 1px #0087A3" }}
                  className="text-[12px] text-[#06513D] font-light px-4 h-[38px] flex items-center"
                  onClick={() => setOpenFilterDialog(true)}
                >
                  <FilterIcon className="mr-2" />
                  FILTER
                </Button>
              </div>
              <div className="w-full">
                <SearchBar width="100%" height="38px" onSearch={handleSearch} />
              </div>
            </div>

            <div className="flex md:hidden flex-col gap-3">
              <div className="flex justify-between items-center">
                <div className="px-3 h-[36px] flex items-center justify-center border border-[#06513D] bg-[#B6D4D933] rounded-md text-[#06513D] text-xs font-light whitespace-nowrap">
                  TOTAL FORMS {filteredData.length}
                </div>
                <Button
                  style={{ background: "#E6EEEC", border: "solid 1px #0087A3" }}
                  className="text-[11px] text-[#06513D] font-light px-3 h-[36px] flex items-center"
                  onClick={() => setOpenFilterDialog(true)}
                >
                  <FilterIcon className="mr-1 w-3 h-3" />
                  FILTER
                </Button>
              </div>
              <div className="w-full">
                <SearchBar width="100%" height="36px" onSearch={handleSearch} />
              </div>
            </div>
          </div>

          <div className="hidden md:block w-full overflow-x-auto">
            <Tables
              headers={headers}
              pageSize={pageSize}
              current={currentPage}
              total={totalForms}
              onChange={(page) => {
                setCurrentPage(page);
                setApiParams((prev) => ({
                  ...prev,
                  skip: (page - 1) * pageSize,
                }));
              }}
              onSort={handleSort}
              sortBy={sortBy}
              sortOrder={sortOrder}
              data={(filteredData || []).map((item) => ({
                ...item,
                serial: (
                  <div className="text-center" title="">
                    {item.serial}
                  </div>
                ),
                formName: (
                  <div
                    style={{
                      textAlign: "center",
                      wordWrap: "break-word",
                      wordBreak: "break-word",
                      whiteSpace: "normal",
                    }}
                    title=""
                  >
                    {item.formName}
                  </div>
                ),
                assigneddate: (
                  <div className="text-center" title="">
                    {item.assigneddate}
                  </div>
                ),
                period: (
                  <div className="text-center" title="">
                    {item.period}
                  </div>
                ),
                projectName: (
                  <div
                    style={{
                      textAlign: "center",
                      wordWrap: "break-word",
                      wordBreak: "break-word",
                      whiteSpace: "normal",
                    }}
                    title=""
                  >
                    {item.projectName}
                  </div>
                ),
                endDate: (
                  <div className="text-center" title="">
                    {item.endDate}
                  </div>
                ),
                formType: (
                  <div className="text-center" title="">
                    {item.formType}
                  </div>
                ),
                status: (
                  <div
                    className="min-w-[140px] text-center rounded-md flex justify-center items-center"
                    title=""
                  >
                    {getStatusBadge(item.status)}
                  </div>
                ),
                action: (
                  <div className="flex gap-2 sm:gap-3 justify-center" title="">
                    <EyeIcon
                      className="cursor-pointer w-4 h-4 sm:w-5 sm:h-5"
                      onClick={() => {
                        if (item.status === "Access Paused") {
                          setErrorPopup({
                            title: "Form Access Temporarily Paused",
                            message:
                              "Your access to this form has been temporarily paused by your administrator. You no longer have permission to view, edit, or submit data for this assignment. Please contact your supervisor or administrator for further information.",
                          });
                          return;
                        }
                        if (
                          item.status === "Access Removed" ||
                          item.status === "Access Revoked"
                        ) {
                          setErrorPopup({
                            title: "Form Access Revoked",
                            message:
                              "Your access to this form has been revoked by your administrator. You no longer have permission to view, edit, or submit data for this assignment. Please contact your supervisor or administrator for further information.",
                          });
                          return;
                        }
                        navigate(
                          `/employee/form-assigned/view/${item.templateId}`,
                          {
                            state: {
                              formName: item.formName,
                              formType: item.formType,
                              templateId: item.templateId,
                              projectId: item.projectId,
                              userId: item.userId,
                              id: item.user_id,
                              standardFormAllotmentId:
                                item.standardFormAllotmentId,
                            },
                          },
                        );
                      }}
                    />
                    {/* <EditIcon
                      className="cursor-pointer w-4 h-4 sm:w-5 sm:h-5"
                      title="Edit Form"
                      onClick={() => {
                        console.log("Editing form:", item);
                      }}
                    /> */}
                  </div>
                ),
              }))}
            />
          </div>

          <div className="md:hidden px-3 pb-4">
            {loading ? (
              <div className="flex justify-center items-center py-12">
                <div className="relative">
                  <div className="w-10 h-10 border-4 border-[#06513D] border-t-transparent rounded-full animate-spin"></div>
                  <div className="absolute inset-0 w-10 h-10 border-4 border-[#06513D] border-opacity-20 rounded-full"></div>
                </div>
              </div>
            ) : filteredData.length === 0 ? (
              <div className="flex flex-col items-center justify-center py-12">
                <div className="w-16 h-16 bg-gray-100 rounded-full flex items-center justify-center mb-4">
                  <div className="text-2xl text-gray-400">📋</div>
                </div>
                <div className="text-gray-500 text-center">
                  <p className="font-medium">No forms found</p>
                  <p className="text-sm mt-1">
                    Try adjusting your search criteria
                  </p>
                </div>
              </div>
            ) : (
              <>
                <div className="space-y-1">
                  {currentPageData.map((item, index) => (
                    <MobileFormCard
                      key={item._id || index}
                      item={item}
                      index={index}
                      navigate={navigate}
                      setErrorPopup={setErrorPopup}
                    />
                  ))}
                </div>
                {filteredData.length > pageSize && (
                  <div className="flex justify-center mt-6 pt-4 border-t border-gray-100">
                    <Pagination
                      current={currentPage}
                      total={totalForms}
                      pageSize={pageSize}
                      onChange={(page) => {
                        setCurrentPage(page);
                        setApiParams((prev) => ({
                          ...prev,
                          skip: (page - 1) * pageSize,
                        }));
                      }}
                      showSizeChanger={false}
                      size="small"
                      showQuickJumper={false}
                      showTotal={(total, range) =>
                        `${range[0]}-${range[1]} of ${total} forms`
                      }
                    />
                  </div>
                )}
              </>
            )}
          </div>

          {openFilterDialog && (
            <FilterAssignedForm
              onOpen={openFilterDialog}
              onClose={() => setOpenFilterDialog(false)}
              onApplyFilter={handleFilterApply}
              filterData={apiParams}
            />
          )}

          {errorPopup && (
            <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-[9999] p-4">
              <PopupCard
                type="error"
                title={errorPopup.title}
                message={errorPopup.message}
                onConfirm={() => setErrorPopup(null)}
                confirmText="Ok"
                widthClass="sm:w-[450px]"
              />
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default FormAssigned;
